import { render } from "./dental_notes.vue?vue&type=template&id=bfa17c60&scoped=true"
import script from "./dental_notes.vue?vue&type=script&lang=js"
export * from "./dental_notes.vue?vue&type=script&lang=js"

import "./dental_notes.vue?vue&type=style&index=0&id=bfa17c60&scoped=true&lang=css"

import exportComponent from "/home/denoh/project/in_client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bfa17c60"]])

export default __exports__